var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","loading":_vm.downloadLoading,"icon":_vm.icon,"size":_vm.size},on:{"click":_vm.exportExcel}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }